import axios from 'axios';
import baseURL from '../../Config';

async function get(path) {
    const login = JSON.parse(localStorage.getItem('adminUser') || localStorage.getItem('userDetails') || '{}');
    const token = login?.data?.token || login?.data?.accessToken;
    if (!token) {
        const error = new Error('Tu sesión ha vencido. Vuelve a iniciar sesión.');
        error.status = 401;
        throw error;
    }
    const response = await axios.get(`${baseURL}sales/leads${path}`, {
        headers: { authorization: `Bearer ${token}` }, timeout: 15000
    });
    return response.data.data;
}

export const getLeads = (filters) => {
    const query = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== '' && value !== undefined) query.set(key, String(value));
    });
    return get(`?${query}`);
};
export const getLead = (id) => get(`/${encodeURIComponent(id)}`);

export const leadErrorMessage = (error) => {
    const status = error?.response?.status || error?.status;
    if (status === 401) return 'Tu sesión ha vencido. Vuelve a iniciar sesión.';
    if (status === 403) return 'No tienes permiso para consultar los leads.';
    if (status === 404) return 'Este lead ya no está disponible.';
    if (status === 400) return 'Revisa los filtros e intenta nuevamente.';
    return 'No pudimos cargar los leads. Revisa la conexión e intenta nuevamente.';
};
